import * as types from "../../mutation-types";

import admin from "router/groups/admin";
import config from "configSite";
import promotion from "router/groups/promotion";
import order from "router/groups/order";
import report from "router/groups/report";
import setting from "router/groups/setting";
import stock from "router/groups/stock";
import storefront from "router/groups/storefront";
import utilities from "router/groups/utilities";

const state = {
  items: [
    storefront,
    {
      name: "Dashboard",
      path: "/dashboard",
      meta: {
        public: false,
        auth: true,
        icon: "fa-tachometer",
        breadcrumb: [{ name: "Dashboard" }],
        link: "dashboard/index.vue",
        permission: [config.permission.DASHBOARD_INDEX]
      },
      component: () => import("views/dashboard/index")
    },
    order,
    {
      name: "Product",
      path: "/product",
      expanded: true,
      meta: {
        public: false,
        auth: true,
        icon: "fa-product-hunt",
        label: "Products",
        breadcrumb: [{ name: "Products" }],
        permission: [
          config.permission.PRODUCTS_INDEX,
          config.permission.PRODUCTS_STORE
        ]
      },
      component: () => import("views/products/index")
    },
    {
      name: "Customer",
      path: "/customer",
      meta: {
        label: "Customers",
        public: false,
        auth: true,
        breadcrumb: [{ name: "Customers" }],
        icon: "fa-user-circle-o",
        permission: [config.permission.CUSTOMERS_INDEX]
      },
      component: () => import("views/customer/index")
    },
    promotion,
    stock,
    {
      name: "Sale Analysis",
      path: "/sale-analysis",
      meta: {
        label: "Sale Analysis",
        public: false,
        auth: true,
        breadcrumb: [{ name: "Sale Analysis" }],
        icon: "fa-line-chart",
        permission: [config.permission.DASHBOARD_INDEX]
      },
      component: () => import("views/sale_analysis/index")
    },
    report,
    utilities,
    {
      name: "Memberships",
      path: "/memberships",
      meta: {
        public: false,
        auth: true,
        icon: "fa-credit-card",
        breadcrumb: [{ name: "Memberships" }],
        permission: [
          config.permission.CUSTOMER_TYPES_INDEX
        ]
      },
      component: () => import("views/customer_type/index")
    },
    setting,
    admin
  ]
};

const mutations = {
  [types.EXPAND_MENU](state, menuItem) {
    if (menuItem.index > -1) {
      if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
        state.items[menuItem.index].meta.expanded = menuItem.expanded;
      }
    } else if (menuItem.item && "expanded" in menuItem.item.meta) {
      menuItem.item.meta.expanded = menuItem.expanded;
    }
  },
  [types.RESET_MENU](state) {
    state.items.forEach(e => {
      if (e?.meta?.expanded) {
        e.meta.expanded = false;
      }
    });
  }
};

export default {
  state,
  mutations
};
